import clsx from 'clsx';

/**
 * A few components + classes that `CartSummary` and `CartSummarySkeleton` share.
 * This is a small file for now and just hits a few common shared pieces,
 * because I feel like we will be overhauling the cart summary block a lot so
 * it's not worth over-engineering.
 *
 * Do not use hooks or read the cart so the skeleton can render this statically.
 */

/**
 * The outer `<section>` of the cart summary block. The skeleton uses this too.
 */
export function CartSummarySection({ children, ...sectionProps }) {
  return (
    <section
      {...sectionProps}
      data-name="cart-summary"
      className="cart-summary bg-dawn-grey-10 px-5 pt-2.5 pb-10 first:pt-10 lg:pt-10 lg:pb-15 lg:first:pt-15"
    >
      {children}
    </section>
  );
}

/**
 * One label/value row in the order summary card.
 */
export function SummaryRow({
  label,
  labelClassName = 'body-r',
  className,
  children
}) {
  return (
    <div
      className={clsx(
        'summary-item flex w-full justify-between pb-4',
        className
      )}
    >
      <div className={labelClassName}>{label}</div>
      {children}
    </div>
  );
}

/**
 * The three class names that decide a line item's size
 */
export const lineItemClassName = 'cart-item mb-5 flex bg-white p-4';
export const lineItemThumbnailFrameClassName =
  'relative flex min-w-13 items-start lg:min-w-20';
export const lineItemThumbnailClassName = 'h-13 w-13 lg:h-20 lg:w-20';

/** Extra classes `SummaryRow` takes for the Order Total row. */
export const orderTotalRowClassName =
  'sh10 order-total-section border-dawn-grey mt-[6px] border-t pt-4';

/**
 * The Affirm message slot. Shared for the height: the widget injects into an
 * empty div, and the skeleton reserves the same space with nothing in it.
 * `min-h-11` rather than `min-h-10` covers Affirm drawing its logo.
 */
export const financeMsgClassName =
  'affirm-as-low-as body-xs min-h-11 pb-6 text-grey-text';

/** Checkout button */
export const checkoutButtonClassName = 'btn btn-primary inline-block w-full';
